// extracted by mini-css-extract-plugin
module.exports = {"card_icon":"dashboard_card_icon__1eX6n"};